import RolesPermisosLayer from "../../components/rolesPermisos/RolesPermisosLayer";

const RolesPermisosPage = () => <RolesPermisosLayer />;

export default RolesPermisosPage;
